module.exports = mobxReact;